/*
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2014 (original work) Open Assessment Technlogies SA (under the project TAO-PRODUCT);
 *
 */

/**
 * @author Sam Sipasseuth <sam@taotesting.com>
 * @author Bertrand Chevrier <bertrand@taotesting.com>
 */
define('taoQtiItem/qtiCommonRenderer/renderers/choices/InlineChoice',[
    'lodash',
    'tpl!taoQtiItem/qtiCommonRenderer/tpl/choices/inlineChoice',
    'taoQtiItem/qtiCommonRenderer/helpers/container'
], function(_, tpl, containerHelper){
    'use strict';

    return {
        qtiClass : 'inlineChoice',
        getContainer : containerHelper.get,
        template : tpl,
        getData : function getData(choice, data){
            data.body = _.unescape(data.body);
            return data;
        }
    };
});

